import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@abb/uikit';
import React from 'react';
export const FaydaPointIcon = (param)=>{
    let { size } = param;
    return /*#__PURE__*/ _jsxs(Icon, {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M9.99912 19.1627C15.0208 19.1627 19.1666 15.0118 19.1666 9.99812C19.1666 4.97716 15.0135 0.833496 9.99185 0.833496C4.97908 0.833496 0.833252 4.97716 0.833252 9.99812C0.833252 15.0118 4.98636 19.1627 9.99912 19.1627Z",
                fill: "url(#paint0_linear_9172_2992)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 9.99795C20 15.4718 15.4812 19.9959 9.9992 19.9959C4.5264 19.9959 0 15.4721 0 9.99795C0 4.51699 4.5187 0 9.99194 0C15.4727 0 20 4.51561 20 9.99795ZM19.1667 9.99795C19.1667 15.0117 15.0209 19.1626 9.9992 19.1626C4.98644 19.1626 0.833333 15.0117 0.833333 9.99795C0.833333 4.977 4.97916 0.833333 9.99194 0.833333C15.0136 0.833333 19.1667 4.977 19.1667 9.99795Z",
                fill: "url(#paint1_linear_9172_2992)"
            }),
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_dd_9172_2992)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.89229 8.55555H13.2308C13.2308 10.1444 11.9293 11.4445 10.3385 11.4445H8.89229V16.5C7.30155 16.5 6 15.2 6 13.6111V4.60017C6 3.99258 6.49312 3.5 7.10148 3.5H12.5077C14.0985 3.5 15.4 4.8 15.4 6.38891H8.89229V8.55555Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.89229 8.59721H8.85062V8.55555V6.38891V6.34724H8.89229H15.358C15.3355 4.8004 14.0616 3.54167 12.5077 3.54167H7.10148C6.51608 3.54167 6.04167 4.01564 6.04167 4.60017V13.6111C6.04167 15.163 7.30185 16.4356 8.85062 16.458V11.4445V11.4028H8.89229H10.3385C11.8924 11.4028 13.1663 10.1441 13.1888 8.59721H8.89229Z",
                        stroke: "black",
                        strokeOpacity: "0.08",
                        strokeWidth: "0.0833333"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter0_dd_9172_2992",
                        x: "4.33333",
                        y: "2.16667",
                        width: "12.7334",
                        height: "16.3333",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "0.333333"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "0.0833333"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_9172_2992"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "0.333333"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "0.833333"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "effect1_dropShadow_9172_2992",
                                result: "effect2_dropShadow_9172_2992"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect2_dropShadow_9172_2992",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_9172_2992",
                        x1: "4.5",
                        y1: "3.5",
                        x2: "16.3546",
                        y2: "16.7336",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#A570FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#7E48FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_9172_2992",
                        x1: "3.625",
                        y1: "2.75",
                        x2: "15.9147",
                        y2: "17.4183",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#C08BFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#652FDD"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
